'use strict';
import React, { PureComponent } from 'react';
import ModelosContablesRegistrosBuscador from './ModelosContablesRegistrosBuscador';
import ModelosSeleccionados from './ModelosSeleccionados';


class ReemplazarModelosContables extends PureComponent {
    constructor(props) {
        super(props);
    
        this.limpiarBusqueda = this.limpiarBusqueda.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.buscarModelos = this.buscarModelos.bind(this);
        this.cambiarInput = this.cambiarInput.bind(this);
        this.seleccionarTodosModelos = this.seleccionarTodosModelos.bind(this);
    }

    cambiarInput() {
        this.props.cambiarInputBuscadorModelosActivo(this.props.nombreInput);
    }

    buscarModelos(event) {
        let valorInput = event.target.value;

        this.props.buscarModelosModalReemplazarCuentasContables(valorInput);
    }

    limpiarBusqueda() {
        this.props.buscarModelosModalReemplazarCuentasContables("");
    }

    onKeyPress(event) {
        let regExp = /[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ \s]/ig;

        if (!regExp.test(event.key)) {
            event.preventDefault();
        }
    }

    seleccionarTodosModelos() {
        this.props.cambiarInputBuscadorModelosActivo("");
        this.props.guardarQuitarModeloSeleccionado(this.props.seccionInput, "Todos", true);
    }

    render() {
        const {
            inputActivo,
            inputModelos,
            modelosContablesFiltrados,
            modelosSeleccionados,
            mostrarVerMas,
            nombreInput,
            seccionInput
        } = this.props;

        //ACTIONS
        const { 
            buscarModelosModalReemplazarCuentasContables,
            cambiarInputBuscadorModelosActivo,
            guardarQuitarModeloSeleccionado,
            ocultarBotonVerMas
        } = this.props;

        let arrayModelos = [];

        //Agrego valor "Todos"
        if(!(modelosSeleccionados[0]?.Codigo == "Todos")) {
            arrayModelos.push(<div key={nombreInput + "Todos"} className="ABMModelos__opcionBuscadorCuentasContables" onClick={this.seleccionarTodosModelos}>
                                Todos
                            </div>
            );

            modelosContablesFiltrados && modelosContablesFiltrados.map(modelo => {
                arrayModelos.push(<ModelosContablesRegistrosBuscador
                                        buscarModelosModalReemplazarCuentasContables={buscarModelosModalReemplazarCuentasContables}
                                        cambiarInputBuscadorModelosActivo={cambiarInputBuscadorModelosActivo}
                                        guardarQuitarModeloSeleccionado={guardarQuitarModeloSeleccionado}
                                        key={nombreInput + modelo.Codigo}
                                        modelo={modelo}
                                        nombreInput={nombreInput}
                                        seccionInput={seccionInput}
                                />);
            });
        }

        arrayModelos = arrayModelos.length == 0 ? 
                                <div className="ABMModelos__opcionBuscadorCuentasContablesSinResultados">No se encontraron resultados</div>
                            : 
                                arrayModelos;

        return (
            <div className="ABMModelosModalContainer__contenedorBuscadorReemplazarCuentas">
                <div>
                    <div className="col-md-12 seccionSuperior__buscador ABMModelosModalContainer__buscadorMargen">
                        <div className="AsientosContables--floatLeft seccionSuperior__iconoLupa ABMModelosModalContainer__iconoLupaInput"></div>

                        <div className="AsientosContables--floatLeft">
                            <input
                                className="textbox-rectangular form-control default-input top-separator-xxxs bottom-separator-xxs seccionSuperior__inputBuscador ABMModelosModalContainer__buscadorAncho"
                                id={"buscadorModelos"}
                                name={"buscadorModelos"}
                                onChange={this.buscarModelos}
                                onClick={this.cambiarInput}
                                onKeyDown={null}
                                onKeyPress={this.onKeyPress}
                                placeholder="Buscar modelos"
                                value={inputModelos}
                            />
                        </div>


                        {inputModelos && inputModelos.length > 0 ?
                            <div className="seccionSuperior__botonBuscador ABMModelosModalContainer__buscadorBotonBorrarBusqueda">
                                <button type="button" className="btn-tag seccionSuperior__botonBorrarBusqueda"
                                    onClick={this.limpiarBusqueda}>
                                    <span className="ti-close span-closable" />
                                </button>
                            </div>
                        :
                            null
                        }
                    </div>

                    <div className={"modalLogIntentosScroll ABMModelos__ContenedorOpcionesBuscadorCuentasContables slider-tarjetas" + (nombreInput == inputActivo ? "" : " closed")}>
                        {arrayModelos}
                    </div>
                </div>

                <div className="modalLogIntentosScroll ABMModelos__scrollModelosSeleccionadosEtiquetas">
                    <ModelosSeleccionados 
                        guardarQuitarModeloSeleccionado={guardarQuitarModeloSeleccionado}
                        modelosSeleccionados={modelosSeleccionados}
                        mostrarVerMas={mostrarVerMas}
                        seccionInput={seccionInput}
                        ocultarBotonVerMas={ocultarBotonVerMas}
                    />
                </div>
            </div>
        );
    }
}

export default ReemplazarModelosContables;